import { TFunc } from 'featuresFed/fed_core/lang_fns/TFunc'
import { DataModel } from 'graphql/DataModelQueries'
import { createContext } from 'react'

export type FedContextData = {
  dataModel?: DataModel | null
  functions?: TFunc[]
  context?: string
  dbg?: any
}

export const FedContext = createContext<FedContextData>({})

